/* global CONFIG */
import trackError from './track-error'

export default {
  get (VueApp, leg) {
    let self = this
    VueApp.$store.commit('booking/setOthersData', {flightPrice: {loading: true, error: ''}})

    let booking = VueApp.$store.state.booking
    let locations = booking.locations
    let filters = booking.filters
    let settings = booking.settings
    let other = VueApp.$store.state.other
    if (other.widgetTab === 'flight') locations = locations.flight
    let service = booking.selected[leg]

    let url = `${CONFIG.d2dAPI}/flight/flight-price`
    VueApp.$sdk.post2(url, {ResultToken: service.token}, r => {
      try {
        if (!r.Status) {
          if (other.widgetTab === 'd2d') {
            VueApp.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
          }

          let msg = r.Message
          if (r.Message === 'Not Available') {
            msg = 'This flight is no longer available.'
            VueApp.$store.commit('booking/unavailableFlight', {
              leg: leg,
              class: booking.airlines[leg].selectedCabin,
              token: service.token
            })

            let tmp = {}
            tmp[leg] = {}
            if (leg === 'leg1') tmp.leg2 = {}
            VueApp.$store.commit('booking/setSelectedData', tmp)
          }

          if (other.widgetTab === 'flight') {
            VueApp.$store.commit('booking/setOthersData', {flightPrice: {loading: false, error: msg}})
          }

          VueApp.$store.commit('global/setAlertData', {show: true, message: msg})
          trackError.track(VueApp, {
            type: 'flight_price',
            data: {
              main_pickup: locations.pickup,
              main_dropoff: locations.dropoff,
              request: {
                url: url,
                payload: {ResultToken: service.token}
              },
              response: r
            }
          })
          VueApp.$store.commit('booking/setOthersData', {activeLeg: leg, servicesPage: 10})
          if (VueApp.$route.name === 'D2DItinerary') VueApp.$router.push('d2dservice')
          return
        }

        let tmpGtag = {}
        tmpGtag[`flight${leg === 'leg1' ? 1 : 2}`] = r.UpdateFareQuote.FareQuoteDetails.JourneyList
        VueApp.$store.commit('gtag/setGtagData', tmpGtag)

        let resToken = r.UpdateFareQuote.FareQuoteDetails.JourneyList.ResultToken
        let tmpFinalPrice = {}
        let tmpLastToken = {}
        tmpFinalPrice[leg] = r
        tmpLastToken[leg] = resToken
        VueApp.$store.commit('booking/setFinalPrice', tmpFinalPrice)
        VueApp.$store.commit('booking/setLastToken', tmpLastToken)
        if (filters.departure.isReturning && settings.customFlight) {
          if (leg === 'leg1') self.get(VueApp, 'leg2')
          else {
            if (other.widgetTab === 'd2d') self.countTotalDiscount(VueApp)
            else self.setLastSelectedFlight(VueApp)
          }
          return
        }
        if (other.widgetTab === 'd2d') self.countTotalDiscount(VueApp)
        else self.setLastSelectedFlight(VueApp)
      } catch (error) {
        VueApp.$store.commit('booking/setOthersData', {activeLeg: leg})
        console.log('flight-price error:', error)
        VueApp.$store.commit('booking/setOthersData', {
          flightPrice: {
            loading: false,
            error: 'Something went wrong. Please try again.'
          }
        })
        VueApp.$store.commit('global/setAlertData', {show: true, message: 'Something went wrong. Please try again.'})
        trackError.track(VueApp, {
          type: 'flight_price',
          data: {
            main_pickup: locations.pickup,
            main_dropoff: locations.dropoff,
            request: {
              url: url,
              payload: {ResultToken: service.token}
            },
            response: '',
            console_error: error
          }
        })
      }
    })
  },

  countTotalDiscount (VueApp) {
    let booking = VueApp.$store.state.booking
    let landQuote = booking.landQuote
    let total = 0
    // let selectedCabin1 = booking.airlines.leg1.selectedCabin
    // let selectedCabin2 = booking.airlines.leg2.selectedCabin
    if (!booking.selected.leg1.cabin) return
    let selectedCabin1 = booking.selected.leg1.cabin
    let selectedCabin2 = booking.selected.leg2.cabin
    if (selectedCabin1 === 'API2') {
      selectedCabin1 = booking.selected.leg1.cabin
      selectedCabin2 = booking.selected.leg2.cabin
    }
    if (!booking.settings.customFlight) selectedCabin2 = selectedCabin1
    total += (landQuote.leg1Depart[selectedCabin1].origPrice - landQuote.leg1Depart[selectedCabin1].price)
    total += (landQuote.leg1Arrive[selectedCabin1].origPrice - landQuote.leg1Arrive[selectedCabin1].price)
    if (booking.filters.departure.isReturning) {
      total += (landQuote.leg2Depart[selectedCabin2].origPrice - landQuote.leg2Depart[selectedCabin2].price)
      total += (landQuote.leg2Arrive[selectedCabin2].origPrice - landQuote.leg2Arrive[selectedCabin2].price)
    }
    VueApp.$store.commit('booking/setOthersData', {totalDiscount: total})
    this.setLastSelectedFlight(VueApp)
  },

  setLastSelectedFlight (VueApp) {
    let booking = VueApp.$store.state.booking
    let filters = booking.filters
    let selected = booking.selected
    let settings = booking.settings

    let leg1 = {
      airlineCode: selected.leg1.flight[0].airline.code,
      flightNo: selected.leg1.flight[0].flightNo,
      date: selected.leg1.flight[0].origin.DateTime,
      arriveDate: selected.leg1.flight[selected.leg1.flight.length - 1].destination.DateTime,
      cabin: booking.airlines.leg1.selectedCabin
    }
    let leg2 = {}
    if (filters.departure.isReturning) {
      let tmpLeg = settings.customFlight ? 'leg2' : 'leg1'
      let tmpFlight = settings.customFlight ? 'flight' : 'returnFlight'
      leg2 = {
        airlineCode: selected[tmpLeg][tmpFlight][0].airline.code,
        flightNo: selected[tmpLeg][tmpFlight][0].flightNo,
        date: selected[tmpLeg][tmpFlight][0].origin.DateTime,
        arriveDate: selected[tmpLeg][tmpFlight][selected[tmpLeg][tmpFlight].length - 1].destination.DateTime,
        cabin: booking.airlines[tmpLeg].selectedCabin
      }
    }
    VueApp.$store.commit('booking/setLastSelectedFlight', {
      leg1: leg1,
      leg2: leg2
    })
    VueApp.$store.commit('global/setSessionModalData', {startTracking: true})
    VueApp.$store.commit('booking/setOthersData', {flightPrice: {loading: false, error: ''}})

    if (VueApp.$store.state.other.widgetTab === 'd2d') {
      VueApp.$store.commit('other/setOtherData', {appLoader: false, appLoaderMsg: ''})
      VueApp.$router.push('d2ditinerary')
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/flight-price.js